import React from "react";
import { Link as RouterLink, useNavigate } from "react-router-dom";
import { Box, Typography, Stack } from "@mui/material";
import backArrow from "../../assets/backArrow.png";

function BpHistoryHeader({ title, subtitle, route, marginTop }) {
  const navigate=useNavigate()
const goBack=()=>{
navigate('/profile')
}
  const TruncatedHeading = ({ text, limit }) => {
    const displayText = text && text.length > limit ? `${text.substring(0, limit)}...` : text;
    return (
      <Typography
        variant="h6"
        sx={{
          color: "#583C43",
          fontFamily: "Roboto",
          fontWeight: 500,
          fontSize: "18px",
          lineHeight: "normal",
          letterSpacing: "0.36px",
        }}
      >
        {displayText}
      </Typography>
    );
  };

  const TruncatedSubheading = ({ text, limit }) => {
    const displayText = text.length > limit ? `${text.substring(0, limit)}...` : text;
    return (
      <Typography
        variant="body2"
        sx={{
          color: "#583C43",
          fontSize: "13px",
          width: "200%",
        }}
      >
        ---{displayText}
      </Typography>
    );
  };

  return (
    <Box
      sx={{
        height: "150px",
        padding: 2,
        backgroundColor: "#FAE14B", // Set background color here
        position:"fixed",
        width:"100%",
marginTop:"-67px"
      }}
    >
      <Stack direction="row" alignItems="center" spacing={1} mt={marginTop}>
        <RouterLink to={route} onClick={()=>{goBack()}}>
          <Box component="img" src={backArrow} sx={{ height: "18px", mr: 1.5 }} />
        </RouterLink>

        <Box sx={{ ml: 1 }}>
          <TruncatedHeading text={title} limit={20} />
          {subtitle && <TruncatedSubheading text={subtitle} limit={40} />}
        </Box>
      </Stack>
    </Box>
  );
}

export default BpHistoryHeader;
